interface CookieOptions {
  path?: string;
  domain?: string;
  expires?: Date;
  secure?: boolean;
  httpOnly?: boolean;
  sameSite?: "Strict" | "Lax" | "None";
}

export const createAuthCookieStorage = () => {
  const setCookie = (name: string, value: string, options: CookieOptions = {}) => {
    const secure = options.secure ?? true;
    const sameSite = options.sameSite ?? "Lax";
    const path = options.path ?? "/";

    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
    cookieString += `; Path=${path}`;

    if (options.expires) {
      cookieString += `; Expires=${options.expires.toUTCString()}`;
    }

    if (secure && typeof window !== "undefined" && window.location?.protocol === "https:") {
      cookieString += "; Secure";
    }

    if (sameSite) cookieString += `; SameSite=${sameSite}`;
    if (options.domain) cookieString += `; Domain=${options.domain}`;

    document.cookie = cookieString;
  };

  const getCookie = (name: string): string | null => {
    const cookies = document.cookie.split(";");
    const cookieName = encodeURIComponent(name);

    for (const cookie of cookies) {
      const [key, value] = cookie.trim().split("=");
      if (key === cookieName && value) {
        return decodeURIComponent(value);
      }
    }

    return null;
  };

  const removeCookie = (name: string, options: CookieOptions = {}) => {
    const opts = {
      ...options,
      expires: new Date(0),
      path: "/",
    };
    setCookie(name, "", opts);
  };

  return {
    getItem: (key: string) => {
      try {
        const value = getCookie(key);
        if (!value) return null;
        return value;
      } catch (error) {
        console.error("Error getting cookie value:", error);
        return null;
      }
    },
    setItem: (key: string, value: string) => {
      try {
        setCookie(key, value, {
          secure: true,
          sameSite: "Lax",
          path: "/",
          expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
        });
      } catch (error) {
        console.error("Error setting cookie:", error);
      }
    },
    removeItem: (key: string) => {
      removeCookie(key);
    },
  };
};
